// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__NmYsd","noInteraction":"EventWrapper_noInteraction__3QLsO"};